import Vue from "vue";
import VueI18n from "vue-i18n";
import es from "../locales/es.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: navigator.language, // set locale
  fallbackLocale: {
    default: ["es"],
  },
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: {
    es,
  },
});

export default i18n;
